export default "__VITE_ASSET__Ccqeo3I0__"